import React, { createRef } from "react";
import Footer from "../../Constant/Footer";
import Sidebar from "../../Constant/sidebar";
import TopBar from "../../Constant/TopBar";
import { toast, ToastContainer } from "react-toastify";
import { Cropper } from "react-advanced-cropper";
import SuperAdminSideMenu from "../Sidemenu";
import SuperAdminTopbar from "../topbar";
import { connect } from "react-redux";
import { GetSuperAdminDetails, UpdateSuperAdminDetails, UpdateSuperAdminPassword } from "../../../actions";
import * as actionType from "../../../constants/actionTypes";

class SuperAdminAccount extends React.Component {
  constructor(props) {
    super(props);

    this.inputRef = createRef();
    this.cropperRef = createRef();

    // Add event listener for ESC key
    window.addEventListener('keydown', this.handleKeyPress);

    this.state = {
      imageSrc: "",
      errorMessage: "",
      current_password_hidden: true,
      new_password_hidden: true,
      confirm_new_password_hidden: true,
      OpenImageModal: false,
      passwordValidationError: "",

      account_setting: {
        avatar: {
          label: "File",
          type: "file",
          value: '',
          thumbnail_image: "/assets/media/school-logo.png",
        },
        first_name: {
          type: "text",
          label: "First Name",
          value: "",
          placeholder: "First Name",
        },
        last_name: {
          type: "text",
          label: "Last Name",
          value: "",
          placeholder: "Last Name",
        },
        email: {
          type: "email",
          label: "Email",
          value: "",
          placeholder: "Email",
        },
        contact_one: {
          type: "tel",
          label: "Contact Number",
          value: "",
        },
        user_id: {
          type: "text",
          label: "User ID",
          value: "",
          placeholder: "User ID",
        },
        user_uuid: {
          type: "text",
          label: "user_uuid",
          value: "",
        },
      },

      manager_password: {
        password: {
          type: "password",
          label: "Current Password",
          value: "",
        },
        new_password: {
          type: "password",
          label: "New Password",
          value: "",
        },
        confirm_new_password: {
          type: "password",
          label: "Confirm New Password",
          value: "",
        },
        user_uuid: {
          type: "text",
          label: "user_uuid",
          value: "",
        },
      },

      // Session settings from API response
      session_settings: {
        never_logout: false,
        auto_logout_time: 15,
        twof_auth: false,
      },
    };
  }

  componentDidMount() {
    this.GetSuperAdminDetails();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
    const { imageSrc } = this.state;
    if (imageSrc) {
      URL.revokeObjectURL(imageSrc);
    }
  }

  handleKeyPress = (event) => {
    if (event.keyCode === 27) {
      this.setState({ OpenImageModal: false })
    }
  };

  GetSuperAdminDetails() {
    const storedUser = localStorage.getItem("bss_authuser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;
    const user_uuid = parsedUser?.user_uuid || this.props.user_uuid;

    if (user_uuid) {
      this.props.GetSuperAdminDetails(user_uuid)
        .then((response) => {
          console.log("super admin details", response);

          if (response && response.success === true) {
            let super_admin_data = response.data;
            
            // Update account settings
            const update_account_setting = { ...this.state.account_setting };
            const update_manager_password = { ...this.state.manager_password };
            
            // Handle avatar - similar to ManagerAccount
            if (super_admin_data.avatar !== null && super_admin_data.avatar !== '') {
              update_account_setting['avatar'].thumbnail_image = actionType.environment_url + '/' + super_admin_data.avatar;
              update_account_setting['avatar'].value = super_admin_data.avatar;
            }

            // Populate account fields
            for (let key in update_account_setting) {
              if (super_admin_data[key] !== undefined && key !== 'avatar') {
                update_account_setting[key].value = super_admin_data[key];
              }
            }

            // Handle password fields
            update_manager_password['password'].value = super_admin_data.original_password || '';
            update_manager_password['user_uuid'].value = super_admin_data.user_uuid || '';

            // Handle session settings from API
            const session_settings = {
              never_logout: super_admin_data.settings ? super_admin_data.settings.never_logout : false,
              auto_logout_time: super_admin_data.settings ? super_admin_data.settings.auto_logout_time : 15,
              twof_auth: super_admin_data.twof_auth || false,
            };

            this.setState({ 
              account_setting: update_account_setting,
              manager_password: update_manager_password,
              session_settings: session_settings
            });

            // Update localStorage with complete user info
            const updated_user_info = { 
              ...parsedUser, 
              avatar: super_admin_data.avatar,
              email: super_admin_data.email,
              first_name: super_admin_data.first_name,
              last_name: super_admin_data.last_name,
              settings: {
                auto_logout_time: super_admin_data.settings ? super_admin_data.settings.auto_logout_time : 0,
                never_logout: super_admin_data.settings ? super_admin_data.settings.never_logout : true
              },
              twof_auth: super_admin_data.twof_auth || false
            };
            localStorage.setItem("bss_authuser", JSON.stringify(updated_user_info));

            // Update autoLogoutSettings in localStorage
            const autoLogoutSettings = {
              neverLogout: super_admin_data.settings ? super_admin_data.settings.never_logout : true,
              logoutTimeMinutes: super_admin_data.settings ? super_admin_data.settings.auto_logout_time : 0
            };
            localStorage.setItem("autoLogoutSettings", JSON.stringify(autoLogoutSettings));
          }
        })
        .catch((error) => {
          console.error("Error fetching super admin details:", error);
        });
    }
  }

  onUpload = () => {
    if (this.inputRef.current) {
      this.inputRef.current.click();
    }
  };

  onLoadImage = (event) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        this.setState({
          errorMessage: "The size of image is too large.",
          imageSrc: null,
        });
      } else {
        this.setState({
          imageSrc: URL.createObjectURL(file),
          errorMessage: "",
        });
      }
    }
    event.target.value = "";
  };

  onCrop = () => {
    const cropper = this.cropperRef.current;
    if (cropper) {
      const canvas = cropper.getCanvas();
      if (canvas) {
        canvas.toBlob((blob) => {
          if (blob) {
            this.inputChangeHandlerimage(blob);
          }
        });
      }
    }
  };

  inputChangeHandlerimage = blob => {
    let url = URL.createObjectURL(blob);
    let file = new File([blob], "image.png", { lastModified: new Date().getTime(), type: blob.type })
    const update_account_setting = { ...this.state.account_setting };
    const form_element = { ...update_account_setting["avatar"] };
    form_element.thumbnail_image = url;
    form_element.value = file;
    update_account_setting["avatar"] = form_element;
    this.setState({ 
      account_setting: update_account_setting,
      OpenImageModal: false
    });
  };

  // Handle input changes for account settings
  inputChangeHandler = (event, identifier) => {
    const update_account_setting = { ...this.state.account_setting };
    const form_element = { ...update_account_setting[identifier] };
    form_element.value = event.target.value;
    update_account_setting[identifier] = form_element;
    this.setState({ account_setting: update_account_setting });
  };

  toggleShow(identifier) {
    if (identifier === "current_password") {
      this.setState({
        current_password_hidden: !this.state.current_password_hidden,
      });
    }
    if (identifier === "new_password") {
      this.setState({
        new_password_hidden: !this.state.new_password_hidden,
      });
    }
    if (identifier === "confirm_new_password") {
      this.setState({
        confirm_new_password_hidden: !this.state.confirm_new_password_hidden,
      });
    }
  }

  // Handle password input changes
  handlePasswordChange = (field, value) => {
    const updatedPassword = { ...this.state.manager_password };
    updatedPassword[field].value = value;

    // Validate password confirmation
    let passwordValidationError = "";
    if (field === "confirm_new_password" || field === "new_password") {
      const newPassword = field === "new_password" ? value : updatedPassword.new_password.value;
      const confirmPassword = field === "confirm_new_password" ? value : updatedPassword.confirm_new_password.value;
      
      if (confirmPassword && newPassword !== confirmPassword) {
        passwordValidationError = "New password and confirm password do not match.";
      }
    }

    this.setState({
      manager_password: updatedPassword,
      passwordValidationError,
    });
  };

  // Handle session logout setting changes
  handleLogoutSettingChange = (settingType) => {
    const newSessionSettings = { ...this.state.session_settings };
    
    if (settingType === "never_logout") {
      newSessionSettings.never_logout = true;
      newSessionSettings.auto_logout_time = 0;
    } else if (settingType === "auto_logout") {
      newSessionSettings.never_logout = false;
      if (newSessionSettings.auto_logout_time === 0) {
        newSessionSettings.auto_logout_time = 15; // Default 15 minutes
      }
    }
    
    this.setState({ session_settings: newSessionSettings });
  };

  // Handle auto logout time input change
  handleAutoLogoutTimeChange = (event) => {
    const value = parseInt(event.target.value) || 0;
    const newSessionSettings = { ...this.state.session_settings };
    newSessionSettings.auto_logout_time = value;
    this.setState({ session_settings: newSessionSettings });
  };

  // Handle authentication method change
  handleAuthMethodChange = (authType) => {
    const newSessionSettings = { ...this.state.session_settings };
    
    if (authType === "normal_login") {
      newSessionSettings.twof_auth = false;
    } else if (authType === "two_factor") {
      newSessionSettings.twof_auth = true;
    }
    
    this.setState({ session_settings: newSessionSettings });
  };
handleUpdateSchool = () => {
  const { account_setting, session_settings } = this.state;

  const storedUser = localStorage.getItem("bss_authuser");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const user_uuid = parsedUser?.user_uuid || this.props.user_uuid;

  const formData = new FormData();

  // Add user_uuid
  if (user_uuid) {
    formData.append("user_uuid", user_uuid);
  }

  // Handle account settings - similar to ManagerAccount
  for (let key in account_setting) {
    let form_element = account_setting[key];
    if (key === 'avatar') {
      // Only append if there's a new file to upload
      if (form_element.value && typeof form_element.value === 'object' && form_element.value instanceof File) {
        formData.append(key, form_element.value);
      }
    } else {
      formData.append(key, form_element.value);
    }
  }

  // Session settings
  const settings = {
    auto_logout_time: session_settings.auto_logout_time,
    never_logout: session_settings.never_logout
  };

  formData.append("settings", JSON.stringify(settings));
  formData.append("twof_auth", session_settings.twof_auth);

  this.props.UpdateSuperAdminDetails(formData)
    .then((res) => {
      console.log("Profile updated successfully", res);
      if (res.success === true) {
        toast.success(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        
        // Update localStorage with new auto-logout settings after successful API call
        const newAutoLogoutSettings = {
          neverLogout: session_settings.never_logout,
          logoutTimeMinutes: session_settings.auto_logout_time
        };
        
        localStorage.setItem("autoLogoutSettings", JSON.stringify(newAutoLogoutSettings));
        
        // Notify AutoLogout component about the change
        window.dispatchEvent(new CustomEvent('autoLogoutSettingsUpdated'));
        
        this.GetSuperAdminDetails(); // Refresh data
      } else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    })
    .catch((err) => {
      toast.error("Error updating profile");
      console.error("Error updating profile", err);
    });
};
  // handleUpdateSchool = () => {
  //   const { account_setting, session_settings } = this.state;

  //   const storedUser = localStorage.getItem("bss_authuser");
  //   const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  //   const user_uuid = parsedUser?.user_uuid || this.props.user_uuid;

  //   const formData = new FormData();

  //   // Add user_uuid
  //   if (user_uuid) {
  //     formData.append("user_uuid", user_uuid);
  //   }

  //   // Handle account settings - similar to ManagerAccount
  //   for (let key in account_setting) {
  //     let form_element = account_setting[key];
  //     if (key === 'avatar') {
  //       // Only append if there's a new file to upload
  //       if (form_element.value && typeof form_element.value === 'object' && form_element.value instanceof File) {
  //         formData.append(key, form_element.value);
  //       }
  //     } else {
  //       formData.append(key, form_element.value);
  //     }
  //   }

  //   // Session settings
  //   const settings = {
  //     auto_logout_time: session_settings.auto_logout_time,
  //     never_logout: session_settings.never_logout
  //   };

  //   formData.append("settings", JSON.stringify(settings));
  //   formData.append("twof_auth", session_settings.twof_auth);

  //   this.props.UpdateSuperAdminDetails(formData)
  //     .then((res) => {
  //       console.log("Profile updated successfully", res);
  //       if (res.success === true) {
  //         toast.success(res.message, {
  //           position: toast.POSITION.TOP_CENTER,
  //         });
  //         this.GetSuperAdminDetails(); // Refresh data
  //       } else {
  //         toast.error(res.message, {
  //           position: toast.POSITION.TOP_CENTER,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       toast.error("Error updating profile");
  //       console.error("Error updating profile", err);
  //     });
  // };

  handleUpdatePassword = () => {
    const { manager_password } = this.state;

    const storedUser = localStorage.getItem("bss_authuser");
    const parsedUser = storedUser ? JSON.parse(storedUser) : null;
    const user_uuid = parsedUser?.user_uuid || this.props.user_uuid;

    // Validate mandatory fields
    if (!manager_password.new_password.value || !manager_password.confirm_new_password.value) {
      toast.error("New password and confirm password are required.");
      return;
    }

    // Validate passwords match
    if (manager_password.new_password.value !== manager_password.confirm_new_password.value) {
      toast.error("New password and confirm password do not match.");
      return;
    }

    const payload = {
      password: manager_password.new_password.value,
      confirm_password: manager_password.confirm_new_password.value,
      user_uuid,
    };

    this.props.UpdateSuperAdminPassword(payload)
      .then((res) => {
        console.log(res, "password update response");
        if (res.success === true) {
          toast.success(res?.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          
          // Clear password fields
          const clearedPassword = {
            password: { type: "password", label: "Current Password", value: "" },
            new_password: { type: "password", label: "New Password", value: "" },
            confirm_new_password: { type: "password", label: "Confirm New Password", value: "" },
            user_uuid: { type: "text", label: "user_uuid", value: user_uuid },
          };
          
          this.setState({
            manager_password: clearedPassword,
            passwordValidationError: ""
          });
          
          // Refresh data
          this.GetSuperAdminDetails();
        } else {
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((err) => {
        toast.error("Error updating password");
        console.error(err);
      });
  };

  render() {
    const { 
      account_setting, 
      manager_password, 
      imageSrc, 
      OpenImageModal, 
      errorMessage,
      session_settings,
      passwordValidationError,
      current_password_hidden,
      new_password_hidden,
      confirm_new_password_hidden
    } = this.state;

    return (
      <>
        {OpenImageModal && (
          <div className="upload-image-outer-div">
            <span
              style={{ float: "right" }}
              className="pointer m-5"
              onClick={() => this.setState({ OpenImageModal: false })}
            >
              <i className="fas fa-times fa-2x" style={{ color: "#ffffff" }}></i>
            </span>

            {imageSrc ? (
              <div className="upload-image-dormitory">
                <div className="example">
                  <div className="example__cropper-wrapper">
                    <Cropper
                      ref={this.cropperRef}
                      className="example__cropper"
                      backgroundClassName="example__cropper-background"
                      src={imageSrc}
                    />
                  </div>
                  <div className="example__buttons-wrapper">
                    <button className="example__button" onClick={this.onUpload}>
                      <input
                        ref={this.inputRef}
                        type="file"
                        accept="image/*"
                        onChange={this.onLoadImage}
                      />
                      Upload image
                    </button>
                    {imageSrc && (
                      <button className="example__button" onClick={this.onCrop}>
                        Submit
                      </button>
                    )}
                  </div>
                  {OpenImageModal && <div className="modal">Image has been updated!</div>}
                </div>
              </div>
            ) : (
              <div className="upload-image-logo-inner-div">
                <div className="upload-input-container">
                  <div className="upload-input" onClick={this.onUpload}>
                    <div>
                      <svg
                        viewBox="0 0 24 24"
                        style={{
                          display: "inline-block",
                          color: "rgb(255, 255, 255)",
                          fill: "currentcolor",
                          height: "32px",
                          width: "32px",
                          userSelect: "none",
                        }}
                      >
                        <circle cx="12" cy="12" r="3.2"></circle>
                        <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path>
                      </svg>
                    </div>
                    <input
                      ref={this.inputRef}
                      type="file"
                      accept="image/*"
                      onChange={this.onLoadImage}
                    />
                    Upload image
                    {errorMessage && (
                      <span className="text-danger font-weight-bold">
                        {errorMessage}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="text-center mt-10 d-flex flex-column align-items-center">
              <span className="text-white font-weight-bold rounded">The image maximum size is 2MB. Please upload png/jpg/jpeg image</span>
            </div>
          </div>
        )}

        <div>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
        
        <div
          id="kt_body"
          className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed"
        >
          <div className="d-flex flex-column flex-root">
            <div className="page d-flex flex-row flex-column-fluid">
              <SuperAdminSideMenu />
              <div className="wrapper d-flex flex-column flex-row-fluid " id="kt_wrapper">
                <SuperAdminTopbar />
                <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                  <div className="post d-flex flex-column-fluid" id="kt_post">
                    <div id="kt_content_container" className="container-fluid">
                      
                      {/* Account Settings */}
                      <div className="card mt-10 mb-xl-10">
                        <div className="card-header border-0 cursor-pointer">
                          <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">Super Admin Account Settings</h3>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row mb-6">
                            <div className="col-lg-4 d-flex flex-column align-items-center">
                              <div className="profile-img-wrap me-auto">
                                <div className="image-style">
                                  <img
                                    alt="profile"
                                    src={account_setting.avatar.thumbnail_image}
                                    className="img-fluid h-100 w-100 rounded-circle"
                                  />
                                </div>
                                <div className="edit-progile-img-btn mt-4">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary px-10 rounded-50 "
                                    onClick={() => this.setState({ OpenImageModal: true })}
                                  >
                                    Upload Image
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-8 pt-5">
                              <div className="row mb-6">
                                <div className="col-md-6">
                                  <label className="fw-bold fs-6 mb-4">{account_setting.first_name.label}</label>
                                  <input
                                    type={account_setting.first_name.type}
                                    value={account_setting.first_name.value || ""}
                                    className="form-control"
                                    placeholder={account_setting.first_name.placeholder}
                                    onChange={(event) => this.inputChangeHandler(event, "first_name")}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="fw-bold fs-6 mb-4">{account_setting.last_name.label}</label>
                                  <input
                                    type={account_setting.last_name.type}
                                    value={account_setting.last_name.value || ""}
                                    className="form-control"
                                    placeholder={account_setting.last_name.placeholder}
                                    onChange={(event) => this.inputChangeHandler(event, "last_name")}
                                  />
                                </div>
                              </div>

                              <div className="row mb-6">
                                <div className="col-6">
                                  <label className="fw-bold fs-6 mb-4">{account_setting.contact_one.label}</label>
                                  <input
                                    type={account_setting.contact_one.type}
                                    value={account_setting.contact_one.value || ""}
                                    className="form-control"
                                    onChange={(event) => this.inputChangeHandler(event, "contact_one")}
                                  />
                                </div>
                                <div className="col-6">
                                  <label className="fw-bold fs-6 mb-4">{account_setting.user_id.label}</label>
                                  <input
                                    type={account_setting.user_id.type}
                                    value={account_setting.user_id.value || ""}
                                    className="form-control"
                                    placeholder={account_setting.user_id.placeholder}
                                    onChange={(event) => this.inputChangeHandler(event, "user_id")}
                                  />
                                </div>
                              </div>

                              <div className="row mb-6">
                                <label className="fw-bold fs-6 mb-4">{account_setting.email.label}</label>
                                <div className="col-lg-12">
                                  <input
                                    type={account_setting.email.type}
                                    value={account_setting.email.value || ""}
                                    className="form-control"
                                    placeholder={account_setting.email.placeholder}
                                    onChange={(event) => this.inputChangeHandler(event, "email")}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Session Auto Logout Setting */}
                          <div className="card mt-10 mb-xl-10">
                            <div className="card-header border-0 cursor-pointer">
                              <div className="card-title m-0">
                                <h3 className="fw-bolder m-0">
                                  <i className="fas fa-clock text-primary me-3"></i>
                                  Session Auto Logout Setting
                                </h3>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row mb-6">
                                <div className="col-lg-6">
                                  <label className="fw-bold fs-6 mb-4">Auto Logout Setting</label>
                                  
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="logout_setting"
                                      id="never_logout"
                                      checked={session_settings.never_logout}
                                      onChange={() => this.handleLogoutSettingChange("never_logout")}
                                    />
                                    <label className="form-check-label fw-bold" htmlFor="never_logout">
                                      Never Logout
                                    </label>
                                    <div className="text-muted fs-7">
                                      Stay logged in until you manually log out.
                                    </div>
                                  </div>

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="logout_setting"
                                      id="auto_logout"
                                      checked={!session_settings.never_logout}
                                      onChange={() => this.handleLogoutSettingChange("auto_logout")}
                                    />
                                    <label className="form-check-label fw-bold" htmlFor="auto_logout">
                                      Auto Logout After Minutes
                                    </label>
                                    <div className="text-muted fs-7">
                                      Automatically logout after specified minutes of inactivity.
                                    </div>
                                  </div>
                                </div>

                                {!session_settings.never_logout && (
                                  <div className="col-lg-6">
                                    <label className="fw-bold fs-6 mb-4">
                                      Logout Time (Minutes) <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      placeholder="Enter minutes"
                                      value={session_settings.auto_logout_time}
                                      onChange={this.handleAutoLogoutTimeChange}
                                      min="1"
                                      max="1440"
                                    />
                                    <div className="text-muted fs-7 mt-2">
                                      You will be logged out automatically after this many minutes of inactivity. 
                                      Warning appears 5 sec before logout.
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Authentication Setting */}
                          <div className="card mt-10 mb-xl-10">
                            <div className="card-header border-0 cursor-pointer">
                              <div className="card-title m-0">
                                <h3 className="fw-bolder m-0">
                                  <i className="fas fa-shield-alt text-primary me-3"></i>
                                  Authentication Setting
                                </h3>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="row mb-6">
                                <div className="col-lg-12">
                                  <label className="fw-bold fs-6 mb-4">Login Authentication Method</label>
                                  
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="auth_method"
                                      id="normal_login"
                                      checked={!session_settings.twof_auth}
                                      onChange={() => this.handleAuthMethodChange("normal_login")}
                                    />
                                    <label className="form-check-label fw-bold" htmlFor="normal_login">
                                      Normal Login
                                    </label>
                                    <div className="text-muted fs-7">
                                      Standard username and password authentication.
                                    </div>
                                  </div>

                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="auth_method"
                                      id="two_factor_auth"
                                      checked={session_settings.twof_auth}
                                      onChange={() => this.handleAuthMethodChange("two_factor")}
                                    />
                                    <label className="form-check-label fw-bold" htmlFor="two_factor_auth">
                                      Two-Factor Authentication (2FA)
                                    </label>
                                    <div className="text-muted fs-7">
                                      Enhanced security with additional verification step.
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex justify-content-end mt-5">
                            <button 
                              type="button" 
                              className="btn btn-primary px-6 btn-sm"   
                              onClick={this.handleUpdateSchool}
                            >
                              Update Profile
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Change Password */}
                      <div className="card mt-10 mb-xl-10">
                        <div className="card-header border-0 cursor-pointer">
                          <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">Change Password</h3>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row mb-1">
                            <div className="col-lg-4">
                              <label className="form-label fs-6 fw-bolder mb-3">{manager_password.password.label}</label>
                              <div className="position-relative">
                                <input
                                  type={current_password_hidden ? "password" : "text"}
                                  value={manager_password.password.value || ""}
                                  className="form-control"
                                  disabled
                                />
                                <span 
                                  onClick={() => this.toggleShow("current_password")} 
                                  className="btn btn-icon position-absolute translate-middle top-50 end-0"
                                >
                                  {current_password_hidden ? <i className="bi bi-eye-slash fs-2"></i> : <i className="bi bi-eye fs-2"></i>}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <label className="form-label fs-6 fw-bolder mb-3">{manager_password.new_password.label} <span className="text-danger">*</span></label>
                              <div className="position-relative">
                                <input
                                  type={new_password_hidden ? "password" : "text"}
                                  value={manager_password.new_password.value || ""}
                                  className="form-control"
                                  required
                                  onChange={(e) => this.handlePasswordChange("new_password", e.target.value)}
                                />
                                <span 
                                  onClick={() => this.toggleShow("new_password")} 
                                  className="btn btn-icon position-absolute translate-middle top-50 end-0"
                                >
                                  {new_password_hidden ? <i className="bi bi-eye-slash fs-2"></i> : <i className="bi bi-eye fs-2"></i>}
                                </span>
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <label className="form-label fs-6 fw-bolder mb-3">{manager_password.confirm_new_password.label} <span className="text-danger">*</span></label>
                              <div className="position-relative">
                                <input
                                  type={confirm_new_password_hidden ? "password" : "text"}
                                  value={manager_password.confirm_new_password.value || ""}
                                  className={`form-control pe-10 ${passwordValidationError ? "is-invalid" : ""}`}
                                  style={passwordValidationError ? { backgroundImage: "none" } : undefined}
                                  required
                                  onChange={(e) => this.handlePasswordChange("confirm_new_password", e.target.value)}
                                />
                                <span
                                  onClick={() => this.toggleShow("confirm_new_password")}
                                  className="btn btn-icon position-absolute translate-middle top-50 end-0"
                                >
                                  {confirm_new_password_hidden ? <i className="bi bi-eye-slash fs-2"></i> : <i className="bi bi-eye fs-2"></i>}
                                </span>
                              </div>
                              {passwordValidationError && (
                                <div className="invalid-feedback d-block">
                                  {passwordValidationError}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="d-flex justify-content-end mt-5">
                            <button 
                              type="button" 
                              className="btn btn-primary px-6 btn-sm"   
                              onClick={this.handleUpdatePassword}
                            >
                              Update Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // Map any state you need from Redux store
});

const mapDispatchToProps = {
  GetSuperAdminDetails,
  UpdateSuperAdminDetails,
  UpdateSuperAdminPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminAccount);